import { Ratio } from '../../helpers/images';
import { Franchises } from '../../types/Franchises';
import { readingTimeCalculator } from '../readingTimeCalculator';
import { getWordCount } from './franchises';

type StoryblokStory = {
  first_published_at: string;
  full_slug: string;
  id: string;
  content: {
    date: string;
    intro: string;
    image: StoryblokImage;
    title: string;
  };
};

export type StoryblokStories = {
  data: {
    StoryItems: {
      items: StoryblokStory[];
      total: number;
    };
  };
};

export type InsightItem = {
  date: string | null;
  full_slug: string;
  id: string;
  image: StoryblokImage | null;
  intro: string | null;
  mediaDuration: string | null;
  ratio: Ratio | null;
  readingTime: number;
  tag: string | null;
  title: string | null;
};

export const mapFranchiseToItem = (franchise: Franchises): InsightItem => ({
  date: franchise.content.date || null,
  full_slug: franchise.full_slug,
  id: franchise.uuid,
  image: franchise.content.poster || null,
  intro: franchise.content.subtitle || null,
  mediaDuration: franchise.content.mediaDuration || null,
  ratio: franchise.content.posterRatio || null,
  readingTime:
    readingTimeCalculator(getWordCount(franchise.content.article)) || 0,
  tag: franchise.content.tag || null,
  title: franchise.content.title || null,
});

export const formatPostCount = (value = 0) => {
  if (value >= 50) return '50+';
  if (value >= 40) return '40+';
  if (value >= 30) return '30+';
  if (value >= 20) return '20+';
  if (value >= 10) return '10+';
  return `${value}`;
};
